import React from "react";
import Hero from "../components/Hero";
import CTAHero from "../components/CTAHero";
import { useCompanyDetails } from "../hooks/useCompanyDetails";

const SupportPage = () => {
  const { data } = useCompanyDetails();
  const supportLink = data?.supportUsLink?.trim();

  const openSupportLink = () => {
    if (!supportLink) return;
    window.open(supportLink, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <Hero page={"support-us"} titleTwo={"Support Us"} />

      <CTAHero
        background="green"
        textColor="green"
        action={supportLink ? openSupportLink : undefined}
        actionText="Help us make a difference"
        xl={false}
      />
    </>
  );
};

export default SupportPage;
